import { render } from "./cart-info.vue?vue&type=template&id=c37e3402"
import script from "./cart-info.vue?vue&type=script&lang=js"
export * from "./cart-info.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__